import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="font-display font-normal tracking-tight text-3xl mb-8">Privacy Policy</h1>
      
      <div className="prose max-w-none">
        <p className="mb-6">Last updated: {new Date().toLocaleDateString()}</p>
        
        <section className="mb-8">
          <h2 className="font-display font-normal tracking-tight text-2xl mb-4">1. Information We Collect</h2>
          <p>When you use Eatsy, we collect:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Information you provide through your Google account (name, email)</li>
            <li>Your venue visits and preferences</li>
            <li>Usage data and interaction with our service</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="font-display font-normal tracking-tight text-2xl mb-4">2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Provide and improve our services</li>
            <li>Personalize your experience</li>
            <li>Send important updates about our service</li>
            <li>Analyze usage patterns to improve functionality</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="font-display font-normal tracking-tight text-2xl mb-4">3. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information. 
            However, no method of transmission over the internet is 100% secure.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="font-display font-normal tracking-tight text-2xl mb-4">4. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:eatsypro@gmail.com" className="text-brand-600 hover:text-brand-800">
              eatsypro@gmail.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;